export const NoResults = () => (
  <svg width='67' height='67' viewBox='0 0 67 67' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_3186_135255)'>
      <path
        d='M50.0877 54.3912H13.6904C9.70483 54.3912 6.47363 51.1609 6.47363 47.176V17.6882C6.47363 13.7032 9.70462 10.473 13.6904 10.473H52.2841C56.2697 10.473 59.5009 13.7032 59.5009 17.6882V47.176'
        stroke='#BBC0C8'
        strokeWidth='3'
        strokeMiterlimit='10'
        strokeLinecap='round'
      />
      <path
        d='M39.8506 47.3809C47.4971 47.3809 53.6958 41.1835 53.6958 33.5387C53.6958 25.8938 47.4971 19.6965 39.8506 19.6965C32.2041 19.6965 26.0054 25.8938 26.0054 33.5387C26.0054 41.1835 32.2041 47.3809 39.8506 47.3809Z'
        stroke='#BBC0C8'
        strokeWidth='3'
        strokeMiterlimit='10'
      />
      <path
        d='M60.527 57.527L48.7974 44.3845'
        stroke='#BBC0C8'
        strokeWidth='3'
        strokeMiterlimit='10'
        strokeLinecap='round'
      />
      <path
        d='M34.0405 27.3478L45.6601 39.7296'
        stroke='#BBC0C8'
        strokeWidth='3'
        strokeMiterlimit='10'
        strokeLinecap='round'
      />
      <path
        d='M45.6601 27.3478L34.0405 39.7296'
        stroke='#BBC0C8'
        strokeWidth='3'
        strokeMiterlimit='10'
        strokeLinecap='round'
      />
      <path d='M46.459 21.3742H59.1078' stroke='#BBC0C8' strokeWidth='3' strokeMiterlimit='10' />
      <path d='M7.25781 21.3742H33.2389' stroke='#BBC0C8' strokeWidth='3' strokeMiterlimit='10' />
    </g>
    <defs>
      <clipPath id='clip0_3186_135255'>
        <rect width='57' height='50' fill='white' transform='translate(5 9)' />
      </clipPath>
    </defs>
  </svg>
);
